import React, { PropsWithChildren, createContext, useContext } from 'react';
import useYellowhiveFlowProductSelectionStore from '@flows/src/store/zustand/flows-products/useYellowhiveFlowProductSelectionStore';

const YellowHiveBasketCalculationContext = createContext<ReturnType<
  typeof useYellowhiveFlowProductSelectionStore
> | null>(null);

export const useYellowHiveBasketCalculation = () => {
  const context = useContext(YellowHiveBasketCalculationContext);
  if (!context) {
    throw new Error(
      'useYellowHiveBasketCalculation must be used within a YellowHiveBasketCalculationProvider',
    );
  }
  return context;
};

interface Props {
  sessionId: string;
}

const YellowHiveBasketCalculationProvider: React.FC<
  PropsWithChildren<Props>
> = ({ children, sessionId }) => {
  const selectionStore = useYellowhiveFlowProductSelectionStore();

  return (
    <YellowHiveBasketCalculationContext.Provider value={selectionStore}>
      {children}
    </YellowHiveBasketCalculationContext.Provider>
  );
};

export default YellowHiveBasketCalculationProvider;
